import SEO from "@/components/SEO";
import CTABanner from "@/components/CTABanner";
import {
  AboutHero, CompanyStory, LeadershipCard, ValuesGrid, HSESystem, WhereWeWork,
} from "@/components/AboutSections";

export default function About() {
  return (
    <>
      <SEO
        title="About | Yaduraj Enterprises"
        description="From Sheo, Barmer — Rajasthan's solar corridor. Asset-backed solar I&C, EPC and electrical contracting led by Managing Director Ran Singh."
      />
      <AboutHero />
      <CompanyStory />
      <LeadershipCard />
      <ValuesGrid />
      <HSESystem />
      <WhereWeWork />
      <CTABanner />
    </>
  );
}
